import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppCoreService } from "src/app/services/app-core.service";
import { NotificationsService } from "src/app/services/notifications.service";
import Swal from "sweetalert2";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ConfigService } from "src/app/services/system-config/configs/configs.service";
import { Utilities } from "../../models/utilities";

interface Configuration {
  code: string;
  category: string;
  categoryname: string;
  configurationcode: string;
  active: boolean;
  configurationdescription?: string;
}

interface ParentCategory {
  categoryname: string;
  configurations: Configuration[];
  isCollapsed: boolean;
  allChecked?: boolean; // Optional for keeping track of the parent's checked state
}
@Component({
  selector: 'app-configure',
  templateUrl: './configure.component.html',
  styleUrls: ['./configure.component.scss']
})

export class ConfigureSettingsComponent implements OnInit, AfterViewInit {
  notificationForm: FormGroup;
  globalConfigurationForm: FormGroup;
  eventsForm: FormGroup;
  isFormSubmitted: boolean;
  eventFormSubmitted: boolean = false;

  notificationTypeList = [];
  eventCategoryList = [];
  isEmailSelected = false;
  isSMSSelected = false;
  isWhatsAppSelected = false;
  data: any;
  configurations: any;
  notificationType: any;
  dataList: any;
  isSMS = false;
  isEmail = false;
  isWhatsApp = false;
  currentOpenIndex: number | null = null;

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  showEventTable = false;
  isAccessTypeCustomer = false;
  isNotificationFormEdit = false;
  notificationId;
  notificationRowData = [];
  parentCategories: ParentCategory[] = [];
  selectedConfigurations: Configuration[] = [];
  useEnterKey: any;

  constructor(
    private formBuilder: FormBuilder,
    private notificationService: NotificationsService,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private configService: ConfigService,
    private utilities: Utilities,
  ) { }

  ngOnInit() {
    this.notificationTypeList = [{ type: 'Email' }, { type: 'SMS' }, { type: 'WhatsApp' }];
    this.eventCategoryList = [{ type: 'All' }, { type: 'Invoice' }, { type: 'Credit Control' }, { type: 'Transaction' }];
    this.notificationForm = this.formBuilder.group({
      chkConfigure: false,
      ddlNotificationType: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
      txtAccountName: [null, Validators.required],
      ddlEventCategory: [this.eventCategoryList[0]?.type, Validators.required],
      emailForm: this.formBuilder.group({
        txtHost: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
        txtFromMail: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
        txtUsername: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
        txtPassword: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
        txtPort: [null, Validators.required],
      }),
      smsForm: this.formBuilder.group({
        txtHost: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
      }),
      whatsappForm: this.formBuilder.group({
        txtHost: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
      })

    });
    this.globalConfigurationForm = this.formBuilder.group({
      key: ['']
    });

    this.eventsForm = this.formBuilder.group({
      eventid: '',
      categories: this.formBuilder.array([])
    });

    this.checkPermission();
    this.getNotificationTypes();
    this.getEventConfigs();
    this.getConfigs();
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.notificationForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate
    this.isAccessTypeCustomer = userData.accessType === 'Customer';
    const permission = userData.config.filter(x => x.categoryname === 'Settings');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  get categories(): FormArray {
    return this.eventsForm.get('categories') as FormArray;
  }

  addCategory(evt) {
    this.categories.push(this.newCategory(evt));
  }

  removeCategory(idx) {
    this.categories.removeAt(idx);
  }

  newCategory(evt?): FormGroup {
    return this.formBuilder.group({
      name: evt.name || '',
      parent: evt.parent || false,
      items: this.formBuilder.array([])
    });
  }

  subItem(itemIndex: number): FormArray {
    return this.categories
      .at(itemIndex)
      .get('items') as FormArray;
  }

  addSubItem(itemIndex: number, item) {
    this.subItem(itemIndex).push(this.newSubItem(item));
  }

  newSubItem(evt?: any): FormGroup {
    // console.log('evt',evt);

    return this.formBuilder.group({
      name: evt?.name || '',
      code: evt?.code || '',
      parent: evt?.parent || false,
      email: [{ value: evt?.email || false, disabled: this.isAccessTypeCustomer && !evt?.email || (evt?.email === null) }],
      sms: [{ value: evt?.sms || false, disabled: this.isAccessTypeCustomer && !evt?.sms || (evt?.sms === null) }],
      whatsapp: [{ value: evt?.whatsapp || false, disabled: this.isAccessTypeCustomer && !evt?.whatsapp || (evt?.whatsapp === null) }],
    });
  }

  getNotificationTypes() {
    try {
      this.notificationService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.notificationRowData = res.data.filter((item: any) => item.eventcategory !== null);
          this.notificationForm.patchValue({
            ddlNotificationType: 'Email',
            ddlEventCategory: 'All'
          })
          this.isEmailSelected = true;
          this.notificationForm.get('emailForm').enable();
          this.notificationForm.get('smsForm').disable();
          this.notificationForm.get('whatsappForm').disable();
        } else {
          // handle some error
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  getEventConfigs() {
    try {
      this.notificationService.GetEventConfigs().subscribe(res => {
        if (res && res?.success) {
          let eventconfiglist = res.data;
          eventconfiglist.forEach((val, idx) => {
            this.addCategory(val);
            val.categories.forEach((item, i) => {
              this.addSubItem(idx, item);
            });
          });

          // console.log(this.categories.controls);
        }
      })
    } catch (e) {
      console.error(e);
    }

  }

  onTypeChange() {
    this.isFormSubmitted = false;
    this.isEmailSelected = false;
    this.isSMSSelected = false;
    this.isWhatsAppSelected = false;
    const notificationType = ['emailForm', 'smsForm', 'whatsappForm'];
    notificationType.forEach((control) => {
      this.notificationForm.get(control).disable();
    })

    const selectedValue = this.notificationForm?.get('ddlNotificationType')?.value;
    const notificationTypeMap = {
      Email: () => {
        this.isEmailSelected = true;
        this.notificationForm.get('emailForm').enable();
      },
      SMS: () => {
        this.isSMSSelected = true;
        this.notificationForm.get('smsForm').enable();
      },
      WhatsApp: () => {
        this.isWhatsAppSelected = true;
        this.notificationForm.get('whatsappForm').enable();
      }
    }
    const notification = notificationTypeMap[selectedValue];

    if (notification)
      notification();
  }

  saveNotificationTypes() {
    try {
      this.isFormSubmitted = true;
      let requestPayload;

      if (this.notificationForm.invalid) {
        return;
      }

      if (this.notificationForm.get('emailForm').enabled && this.notificationForm.get('emailForm').valid) {
        requestPayload = this.manageNotification();
      } else if (this.notificationForm.get('smsForm').enabled && this.notificationForm.get('smsForm').valid) {
        requestPayload = this.manageNotification();
      } else if (this.notificationForm.get('whatsappForm').enabled && this.notificationForm.get('whatsappForm').valid) {
        requestPayload = this.manageNotification();
      }

      if (this.isNotificationFormEdit) {

        this.ngxLoaderService.start();
        this.notificationService.UpdateNotification(requestPayload).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Record updated successfully', 'Success', 'success');
            this.resetNotificationForm();
            this.getNotificationTypes();
          } else if (res && !res.success) {
            this.ngxLoaderService.stop();
            const message = res.message.includes('Http failure') ? 'Internal Server Error' : res.message;
            this.appCoreService.showMessage(message, 'Error', 'error');
          }
        });

      } else if (!this.isNotificationFormEdit) {

        this.ngxLoaderService.start();
        this.notificationService.AddNotification(requestPayload).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Record Added Successfully', 'Success', 'success');
            this.resetNotificationForm();
            this.getNotificationTypes();
          } else if (res && !res.success) {
            this.ngxLoaderService.stop();
            const message = res.message.includes('Http failure') ? 'Internal Server Error' : res.message;
            this.appCoreService.showMessage(message, 'Error', 'error');
          }
        });

      }

    } catch (err) {
      this.ngxLoaderService.stop();
    }
  }

  saveEventsConfig() {
    this.eventFormSubmitted = true;
    // console.log(this.eventsForm);
    if (this.eventsForm.valid) {
      let requestObj = this.eventsForm.getRawValue();
      this.ngxLoaderService.start();
      this.notificationService.UpdateEventConfigs(requestObj).subscribe(res => {
        // console.log(res);
        if (res && res?.success) {
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage('Record Saved Successfully.', 'Success', 'success');
          this.showEventTable = false;
          this.hide();
        } else if(!res?.success){
          this.ngxLoaderService.stop();
        }
      })
    }
  }

  portValidate(event: KeyboardEvent): void {
    const val = (event.target as HTMLInputElement).value;
    if (event.keyCode !== 8 && event.keyCode !== 9 && event.keyCode !== 46 && val?.length >= 5) {
      event.preventDefault();
    }
    if (event.keyCode == 69 || event.keyCode == 107) {
      event.preventDefault();
    }
  }

  showConfiguration() {
    document.body.classList.toggle('right-bar-enabled');
  }

  hide() {
    document.body.classList.remove('right-bar-enabled');
    this.notificationForm.get('chkConfigure').setValue(false);
  }

  editAction(data: any) {
    this.isNotificationFormEdit = true;
    this.notificationForm.get('ddlNotificationType').disable();
    this.notificationId = data?.id;
    this.manageNotification(data, true);
  }

  deleteAction(cell: any) {
    this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
  }

  deleteRecord(id) {
    try {
      if (id) {
        this.ngxLoaderService.start();
        this.notificationService.DeleteNotification(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Record deleted successfuly', 'Success', 'success');
            this.getNotificationTypes();
          } else if (res && !res.success) {
            this.ngxLoaderService.stop();
            const message = res.message.includes('Http failure') ? 'Internal Server Error' : res.message;
            this.appCoreService.showMessage(message, 'Error', 'error');
          }
        })
      }
    } catch (err) {
      this.ngxLoaderService.stop();
    }
  }

  manageNotification(data?: any, isBind: boolean = false) {
    if (isBind) {
      const configMap = {
        Email: () => ({
          ddlNotificationType: data?.type,
          txtAccountName: data?.accountname,
          ddlEventCategory: data?.eventcategory,
          emailForm: {
            txtHost: data?.config?.host,
            txtFromMail: data?.config?.fromaddress,
            txtUsername: data?.config?.username,
            txtPassword: data?.config?.password,
            txtPort: data?.config?.port,
          }
        }),
        SMS: () => ({
          ddlNotificationType: data?.type,
          txtAccountName: data?.accountname,
          ddlEventCategory: data?.eventcategory,
          smsForm: {
            txtHost: data?.config?.host,
          }
        }),
        WhatsApp: () => ({
          ddlNotificationType: data?.type,
          txtAccountName: data?.accountname,
          ddlEventCategory: data?.eventcategory,
          whatsappForm: {
            txtHost: data?.config?.host,
          }
        })
      };

      const patchData = configMap[data?.type];
      if (patchData) {
        this.notificationForm.patchValue(patchData());
        this.onTypeChange();
      }
    } else {
      const notificationType = this.notificationForm.get('ddlNotificationType')?.value;
      const notificationFormData = {
        Email: () => ({
          type: 'Email',
          id: this.notificationId,
          accountname: this.notificationForm.get('txtAccountName')?.value,
          eventcategory: this.notificationForm.get('ddlEventCategory')?.value,
          config: {
            host: this.notificationForm.get('emailForm').get('txtHost').value,
            username: this.notificationForm.get('emailForm').get('txtUsername').value,
            password: this.notificationForm.get('emailForm').get('txtPassword').value,
            fromaddress: this.notificationForm.get('emailForm').get('txtFromMail').value,
            port: this.notificationForm.get('emailForm').get('txtPort').value
          }
        }),
        SMS: () => ({
          type: 'SMS',
          id: this.notificationId,
          accountname: this.notificationForm.get('txtAccountName')?.value,
          eventcategory: this.notificationForm.get('ddlEventCategory')?.value,
          config: {
            host: this.notificationForm.get('smsForm').get('txtHost').value,
          }
        }),
        WhatsApp: () => ({
          type: 'WhatsApp',
          id: this.notificationId,
          accountname: this.notificationForm.get('txtAccountName')?.value,
          eventcategory: this.notificationForm.get('ddlEventCategory')?.value,
          config: {
            host: this.notificationForm.get('whatsappForm').get('txtHost').value,
          }
        })
      }
      const notification = notificationFormData[notificationType];
      if (notification)
        return notification();
    }
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      this.deleteRecord(id);
    }
  }

  resetNotificationForm() {
    this.isNotificationFormEdit = false;
    this.notificationId = null;
    this.notificationForm.reset();
    this.notificationForm?.get('ddlNotificationType')?.setValue('Email');
    this.notificationForm?.get('ddlNotificationType').enable();
    this.onTypeChange();
  }

  getConfigs() {
    this.configService.getAllGlobalConfig().subscribe((res) => {
      if (res && res.success) {
        this.configurations = res.data;
        let filterSelectedConfigs = this.configurations.filter(x => x.active == true);
        this.groupConfigurations();
      }
    })
  }

  public groupConfigurations(): void {
    const grouped = this.configurations.reduce((acc, config) => {
      const { categoryname } = config;

      if (!acc[categoryname]) {
        acc[categoryname] = {
          categoryname,
          configurations: [],
          isCollapsed: false,
          allChecked: false
        };
      }

      acc[categoryname].configurations.push(config);

      if (config.active) {
        acc[categoryname].allChecked = true;
      }

      return acc;
    }, {} as Record<string, ParentCategory>);

    this.parentCategories = Object.values(grouped);
  }

  toggleCollapse(index: number): void {
    this.parentCategories.forEach((parent, i) => {
      parent.isCollapsed = i !== index ? true : !parent.isCollapsed;
    });
  }


  areAllChildrenChecked(configurations: Configuration[]): boolean {
    return configurations.every(config => config.active);
  }

  onCheckboxChange(categoryname: string, configurationcode: string, isChecked: boolean): void {
    const index = this.selectedConfigurations.findIndex(
      (config) => config.category === categoryname && config.code === configurationcode
    );

    if (isChecked) {
      if (index === -1) {
        this.selectedConfigurations.push({
          category: categoryname,
          code: configurationcode,
          active: true,
          categoryname: "",
          configurationcode: ""
        });
      } else {
        this.selectedConfigurations[index].active = true;
      }
    } else {
      if (index !== -1) {
        this.selectedConfigurations[index].active = false;
      }
    }
  }


  onChildCheckboxChange(parent: any, config: any, isChecked: boolean): void {
    config.active = isChecked;
    parent.allChecked = parent.configurations.some(child => child.active);
  }

  onParentCheckboxChange(parent: any, isChecked: boolean): void {
    parent.configurations.forEach(config => {
      config.active = isChecked;
    });
  }
  updateGlobalConfigurations() {
    const submittedConfigurations = this.parentCategories.flatMap(parent =>
      parent.configurations.map(config => ({
        category: parent.categoryname,
        code: config.configurationcode,
        active: config.active
      }))
    );

    this.ngxLoaderService.start();
    this.configService.updateGlobalConfig(submittedConfigurations).subscribe((res) => {
      if (res && res.success) {
        this.ngxLoaderService.stop();
        this.appCoreService.showMessage('Config Updated Successfully');
        this.getConfigs()
      }
    })
    this.ngxLoaderService.stop();
  }
}
